var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutManager',{attrs:{"mode":_vm.layoutMode,"layout-data":_vm.layoutData,"stallholder-data":_vm.stallholderData}})
}
var staticRenderFns = []

export { render, staticRenderFns }